import { Link } from 'react-router-dom';
import { Building2, MapPin } from 'lucide-react';

interface Props {
  id: string;
  name: string;
  logoUrl?: string | null;
  city?: string | null;
  saleCount: number;
  rentCount: number;
}

export function FeaturedAgencyCard({ id, name, logoUrl, city, saleCount, rentCount }: Props) {
  const summary = saleCount && rentCount
    ? `${saleCount} for Sale | ${rentCount} for Rent`
    : saleCount ? `${saleCount} for Sale` : rentCount ? `${rentCount} for Rent` : 'No active listings';

  return (
    <Link
      to={`/agencies/${id}`}
      className="snap-start shrink-0 w-[260px] h-[100px] flex items-center gap-3 p-3 rounded-lg border bg-card hover:shadow-md transition-all"
    >
      <div className="h-14 w-14 shrink-0 rounded-md border bg-muted/30 flex items-center justify-center overflow-hidden">
        {logoUrl ? (
          <img src={logoUrl} alt={name} className="h-full w-full object-contain" />
        ) : (
          <Building2 className="h-6 w-6 text-muted-foreground" />
        )}
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="font-bold text-sm truncate">{name}</h3>
        <p className="text-xs text-muted-foreground mt-0.5">{summary}</p>
        {city && (
          <p className="flex items-center gap-1 text-xs text-emerald-600 mt-1">
            <MapPin className="h-3 w-3" /> {city}
          </p>
        )}
      </div>
    </Link>
  );
}
